import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const TechnicalNavItem = _ref => {
  let {
    report,
    claimGroup,
    user,
    tab,
    id,
    disabled,
    page
  } = _ref;
  const {
    t
  } = useTranslation();
  const tabName = () => {
    switch (tab.name) {
      case 'DeSection::AdditionalInformation':
        if (tab.type === 'basic') {
          return t('further_requests'.concat("_", tab.iteration_count));
        } else {
          return t('objection');
        }
      case 'DeSection::BsfzCertificate':
        if (tab.sequence === 'initial') {
          return t('bsfz_certificate');
        } else {
          return t('bsfz_certificate') + ' 2';
        }
      default:
        return '';
    }
  };
  const linkName = () => {
    switch (tab.name) {
      case 'DeSection::AdditionalInformation':
        return 'additional_informations';
      case 'DeSection::BsfzCertificate':
        return 'bsfz_certificates';
      default:
        return '';
    }
  };
  const isActiveTab = () => {
    switch (page) {
      case 'further_requests':
        if (tab.type === 'basic') {
          return 'DeSection::AdditionalInformation' === tab.name && +id === tab.id;
        } else if (tab.type === 'objection') {
          return 'DeSection::AdditionalInformation' === tab.name && +id === tab.id;
        }
        return false;
      case 'bsfz_certificate':
        if (tab.sequence === 'initial') {
          return 'DeSection::BsfzCertificate' === tab.name && +id === tab.id;
        } else {
          return 'DeSection::BsfzCertificate' === tab.name && +id === tab.id;
        }
      default:
        return false;
    }
  };
  return /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    disabled: disabled,
    as: Link,
    active: isActiveTab(),
    to: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/technical_proof/project_reports/").concat(report.id, "/").concat(linkName(), "/").concat(tab.id)
  }, tabName()));
};
export default TechnicalNavItem;